import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container animated fadeIn mt-4" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-weight-bold text-secondary text-center" }, " My Bank Accounts & Wallets ")
  ])
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row mt-4" }
const _hoisted_6 = { class: "col d-flex justify-content-end" }
const _hoisted_7 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sat-street text-white" }, "Add +", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListBankAccountItem = _resolveComponent("ListBankAccountItem")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getAccounts, (account) => {
          return (_openBlock(), _createBlock(_component_ListBankAccountItem, {
            item: account,
            key: account.id
          }, null, 8, ["item"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: { name: 'bank.account.form' } }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}